export enum SalaryInsuranceStateEnum {
  START_SCREEN = "START_SCREEN",
  FORM_SCREEN = "FORM_SCREEN",
  SUCCESS_SCREEN = "SUCCESS_SCREEN",
  ERROR_SCREEN = "ERROR_SCREEN",
  LOADING_SCREEN = "LOADING_SCREEN",
  CALCULATOR_SCREEN = "CALCULATOR_SCREEN",
}
